require('./sticky-menu');
import $ from 'jquery';

window.$ = window.jQuery = $;
import 'slick-carousel'


require('./image-slider.js');

$('.usp-slider').slick({
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 3,
    arrows: false,
    centerMode: true,

    responsive: [
        {
            breakpoint: 1280,
            settings: {
                arrows: false,
                dots: true,
                centerMode: false,
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768,
            settings: {
                centerMode: true,
                variableWidth: true,
                arrows: false,
                dots: true,
                slidesToShow: 1.5,
                infinite: false
            }
        }
    ]
});

$('.activity-slider').slick({
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 4,
    arrows: false,
    dots: true,
    responsive: [
        {
            breakpoint: 1280,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1
            }
        }
    ]
});


$('.sponsor-slider').slick({
    infinite: true,
    autoplay: true,
    slidesToScroll: 1,
    slidesToShow: 3,
    arrows: false,
    dots: true,
    responsive: [
        {
            breakpoint: 1280,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1
            }
        }
    ]
});

// change select placeholder color
$('select.input-lg').change(function () {
    if (!$(this).find(":selected").val()) {
        $(this).addClass('text-placeholder').removeClass('text-grey');
    } else {
        $(this).removeClass('text-placeholder').addClass('text-grey');
    }
});

$('.news-slider').slick({
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 3,
    arrows: false,
    responsive: [
        {
            breakpoint: 1280,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                dots: true,
                infinite: false,
                slidesToShow: 1.1
            }
        }
    ]
});

$('.sneekweek-news-slider').slick({
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 2,
    arrows: false,
    responsive: [
        {
            breakpoint: 1280,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                dots: true,
                infinite: false,
                slidesToShow: 1.1
            }
        }
    ]
});

$('.twitter-slider').slick({
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 3,
    arrows: false,
    responsive: [
        {
            breakpoint: 1280,
            settings: {
                arrows: false,
                dots: false,
                slidesToShow: 2.1
            }
        },
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                dots: false,
                infinite: false,
                slidesToShow: 1.1
            }
        }
    ]
});

jQuery(function ($) {

    $(".mobile-menu-toggle").click(function () {
        var panel = $("#mobileMenu .slide-panel");
        var overlay = $("#mobileMenu .slide-background");

        if (!panel.hasClass('open')) {
            $("#mobileMenu").removeClass('hidden');
            setTimeout(function () {
                panel.toggleClass('translate-x-full open')
                overlay.toggleClass('opacity-0');
            }, 10);
        } else {
            panel.toggleClass('translate-x-full open')
            overlay.toggleClass('opacity-0');

            setTimeout(function () {
                if (!panel.hasClass('open')) {
                    $("#mobileMenu").toggleClass('hidden')
                }
            }, 750);
        }
    });

    $('.media-lightbox-open').on('click', function () {
        window.mediaLightbox.api.open();
    });

    $('.maps-lightbox-open').on('click', function () {
        window.mapsLightbox.api.open();
    });

    $('.videos-lightbox-open').on('click', function () {
        window.videosLightbox.api.open();
    });
});

document.addEventListener("DOMContentLoaded", function () {
    let lazyImages = [].slice.call(document.querySelectorAll(".lazy-load"));

    if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    let lazyImage = entry.target;
                    if (lazyImage.nodeName.toLowerCase() === "div") {
                        lazyImage.style.backgroundImage = 'url("' + lazyImage.dataset.src + '")';
                    } else {
                        lazyImage.src = lazyImage.dataset.src;
                    }

                    lazyImage.classList.remove("lazy-load");
                    lazyImageObserver.unobserve(lazyImage);

                }
            });
        });

        lazyImages.forEach(function (lazyImage) {
            lazyImageObserver.observe(lazyImage);
        });
    } else {
        // Possibly fall back to a more compatible method here
    }
}, {passive: true});

// Back to top
$(window).scroll(function () {
    let scrollTop = $(window).scrollTop();
    let width = $(window).width();

    if (width < 768) {
        if (scrollTop > 100) {
            $('.back-to-top-link').fadeIn();
        } else {
            $('.back-to-top-link').fadeOut();
        }
    } else {
        $('.back-to-top-link').hide();
    }

});

$('.site-popup').each(function () {
    let popupId = $(this).attr('data-popup-id');
    if (popupId && document.cookie.indexOf("popup_" + popupId + "_hidden=") > -1) {
        $(this).remove();
    }
});


$('.close-site-popup').on('click', function () {
    let popupId = $(this).attr('data-popup-id');
    if (popupId) {
        document.cookie = "popup_" + popupId + "_hidden=yes;"
        $('.site-popup-' + popupId).remove();
    }

});


$('.tweet-box').on('click', function () {
    let id = $(this).attr('id') + '-holder';
    console.log(id + '-holder', $(id + '-holder'));
    $('#' + id).removeClass('twitter-text-contain');
})

$(document).ready(function () {
    // Hide the submenu items
    $('.nav-items ul').hide();

    // Add the 'submenu-parent' class to the parent menu items
    $('.nav-items > li > ul').parent('li').addClass('submenu-parent');

    // Append the chevron icon to the parent menu items
    $('.submenu-parent > a').append('<i class="ml-1 fas fa-chevron-down"></i>');

    // Toggle the submenu visibility on parent menu item click and animate the chevron icon
    $('.nav-items > li.submenu-parent > a').click(function (e) {
        e.preventDefault(); // Prevent the default link behavior
        $(this).siblings('ul').slideToggle();

        // Rotate the chevron icon
        $(this).find('.fas.fa-chevron-down').toggleClass('rotate-chevron');
    });

    $('.match-show-iframe').click(function (e) { // on click file is in components/matches/entry/top-component
        $('.match-iframe-container').addClass('hidden');
        $('.match-iframe').addClass('hidden');

        let iframeClassToShow = $(this).data('iframe-class');
        $('.match-iframe-container').removeClass('hidden');
        $('.' + iframeClassToShow).removeClass('hidden');
    })


});